(function () {
  'use strict';

  var STORAGE_KEY = 'kc_wishlist';

  var i18n = {
    sv: { empty: 'Din önskelista är tom.', add_to_cart: 'Lägg i varukorg', add_all: 'Lägg till alla i varukorgen', remove: 'Ta bort', added: 'Tillagd!', adding: 'Lägger till...', btn_add: 'Lägg till i önskelista', btn_active: 'I önskelistan' },
    en: { empty: 'Your wishlist is empty.', add_to_cart: 'Add to cart', add_all: 'Add all to cart', remove: 'Remove', added: 'Added!', adding: 'Adding...', btn_add: 'Add to wishlist', btn_active: 'In wishlist' },
    no: { empty: 'Ønskelisten din er tom.', add_to_cart: 'Legg i handlekurv', add_all: 'Legg alle i handlekurven', remove: 'Fjern', added: 'Lagt til!', adding: 'Legger til...', btn_add: 'Legg til i ønskeliste', btn_active: 'I ønskelisten' }
  };

  function getLang() {
    var lang = (document.documentElement.lang || 'sv').toLowerCase();
    if (lang === 'no' || lang === 'nb' || lang === 'nn' || lang.indexOf('no') === 0 || lang.indexOf('nb') === 0) return 'no';
    if (lang.indexOf('en') === 0) return 'en';
    return 'sv';
  }

  function t(key) { return (i18n[getLang()] || i18n.sv)[key] || key; }

  function getWishlist() {
    try { return JSON.parse(localStorage.getItem(STORAGE_KEY) || '[]'); } catch (e) { return []; }
  }

  function saveWishlist(list) {
    localStorage.setItem(STORAGE_KEY, JSON.stringify(list));
    window.dispatchEvent(new CustomEvent('kc:wishlist:updated', { detail: { list: list } }));
  }

  function isInWishlist(variantId) {
    return getWishlist().some(function (i) { return String(i.variantId) === String(variantId); });
  }

  function addToWishlist(product) {
    var list = getWishlist();
    if (!list.some(function (i) { return String(i.variantId) === String(product.variantId); })) {
      list.push(product);
      saveWishlist(list);
    }
  }

  function removeFromWishlist(variantId) {
    saveWishlist(getWishlist().filter(function (i) { return String(i.variantId) !== String(variantId); }));
  }

  function updateHeaderBubble() {
    var count = getWishlist().length;
    document.querySelectorAll('.kc-wishlist-bubble').forEach(function (el) {
      el.textContent = count > 0 ? count : '';
      if (count > 0) { el.removeAttribute('hidden'); } else { el.setAttribute('hidden', ''); }
    });
  }

  function syncButtons(variantId) {
    var active = isInWishlist(variantId);
    document.querySelectorAll('[data-kc-wishlist-variant="' + variantId + '"]').forEach(function (btn) {
      btn.classList.toggle('kc-wishlist-btn--active', active);
      btn.setAttribute('aria-pressed', String(active));
      var label = btn.querySelector('.kc-wishlist-btn__label');
      if (label) label.textContent = active ? (btn.dataset.labelActive || t('btn_active')) : (btn.dataset.labelAdd || t('btn_add'));
    });
  }

  function syncAllButtons() {
    var list = getWishlist();
    document.querySelectorAll('[data-kc-wishlist-variant]').forEach(function (btn) {
      var vid = btn.dataset.kcWishlistVariant;
      var active = list.some(function (i) { return String(i.variantId) === String(vid); });
      btn.classList.toggle('kc-wishlist-btn--active', active);
      btn.setAttribute('aria-pressed', String(active));
      var label = btn.querySelector('.kc-wishlist-btn__label');
      if (label) label.textContent = active ? (btn.dataset.labelActive || t('btn_active')) : (btn.dataset.labelAdd || t('btn_add'));
    });
    updateHeaderBubble();
  }

  function handleToggle(btn) {
    var variantId = btn.dataset.kcWishlistVariant;
    if (isInWishlist(variantId)) {
      removeFromWishlist(variantId);
    } else {
      addToWishlist({
        variantId: variantId,
        productId: btn.dataset.kcWishlistProduct,
        title: btn.dataset.kcWishlistTitle,
        vendor: btn.dataset.kcWishlistVendor || '',
        price: btn.dataset.kcWishlistPrice,
        image: btn.dataset.kcWishlistImage,
        url: btn.dataset.kcWishlistUrl
      });
    }
    syncButtons(variantId);
    updateHeaderBubble();
  }

  function getLocaleRoot() {
    var path = window.location.pathname;
    var match = path.match(/^(\/[a-z]{2}(?:-[a-z]{2})?\/)/i);
    return match ? match[1] : '/';
  }

  async function dispatchCartUpdate(cart) {
    try {
      var localeRoot = getLocaleRoot();
      var sectionsRes = await fetch(localeRoot + '?sections=cart-drawer&t=' + Date.now());
      var sections = sectionsRes.ok ? await sectionsRes.json() : {};
      document.dispatchEvent(new CustomEvent('cart:update', { bubbles: true, detail: { resource: cart, sourceId: 'kc-wishlist', data: { itemCount: cart.item_count, sections: sections } } }));
    } catch (e) {
      document.dispatchEvent(new CustomEvent('cart:update', { bubbles: true, detail: { resource: cart, sourceId: 'kc-wishlist', data: { itemCount: cart.item_count } } }));
    }
    // Re-rendering the cart-drawer section can momentarily disturb the
    // wishlist header bubble's text/visibility if any shared DOM region is
    // morphed. Re-apply our own bubble state right after, and a couple more
    // times shortly after to win any timing race with Horizon's own morph.
    updateHeaderBubble();
    requestAnimationFrame(updateHeaderBubble);
    setTimeout(updateHeaderBubble, 150);
    setTimeout(updateHeaderBubble, 400);
  }

  function openCartDrawer() {
    var drawerComponent = document.querySelector('cart-drawer-component');
    if (drawerComponent && typeof drawerComponent.open === 'function') {
      drawerComponent.open();
    } else {
      var btn = document.querySelector('[data-testid="cart-drawer-trigger"]');
      if (btn) btn.click();
    }
  }

  function refreshCartBubble(count) {
    document.querySelectorAll('.cart-bubble__text-count').forEach(function (el) { el.textContent = count > 0 ? String(count) : ''; });
    document.querySelectorAll('.cart-bubble').forEach(function (el) {
      if (count > 0) { el.removeAttribute('hidden'); } else { el.setAttribute('hidden', ''); }
    });
  }

  async function addToCart(variantId, btn) {
    btn.disabled = true;
    var origText = btn.textContent;
    btn.textContent = t('adding');
    try {
      var res = await fetch('/cart/add.js', { method: 'POST', headers: { 'Content-Type': 'application/json' }, body: JSON.stringify({ id: Number(variantId), quantity: 1 }) });
      if (res.ok) {
        var cart = await (await fetch('/cart.js')).json();
        btn.textContent = t('added');
        refreshCartBubble(cart.item_count);
        await dispatchCartUpdate(cart);
        setTimeout(openCartDrawer, 100);
      } else { btn.textContent = origText; }
    } catch (e) { btn.textContent = origText; }
    finally { btn.disabled = false; setTimeout(function () { btn.textContent = origText; }, 2500); }
  }

  async function addAllToCart(btn) {
    var list = getWishlist();
    if (!list.length) return;
    btn.disabled = true;
    var origText = btn.textContent;
    btn.textContent = t('adding');
    try {
      var items = list.map(function (i) { return { id: Number(i.variantId), quantity: 1 }; });
      var res = await fetch('/cart/add.js', { method: 'POST', headers: { 'Content-Type': 'application/json' }, body: JSON.stringify({ items: items }) });
      if (res.ok) {
        var cart = await (await fetch('/cart.js')).json();
        btn.textContent = t('added');
        refreshCartBubble(cart.item_count);
        await dispatchCartUpdate(cart);
        setTimeout(openCartDrawer, 100);
      } else { btn.textContent = origText; }
    } catch (e) { btn.textContent = origText; }
    finally { btn.disabled = false; setTimeout(function () { btn.textContent = origText; }, 2500); }
  }

  function getTitleWithoutVendor(title, vendor) {
    if (!vendor) return title;
    return title.replace(vendor, '').trim() || title;
  }

  async function renderWishlistPage(container) {
    var list = getWishlist();
    if (list.length === 0) {
      container.innerHTML = '<p class="kc-wishlist-empty">' + t('empty') + '</p>';
      return;
    }

    var grid = document.createElement('div');
    grid.className = 'kc-wishlist-grid';

    var cards = list.map(function (item) {
      var vendor = item.vendor || '';
      var displayTitle = getTitleWithoutVendor(item.title, vendor);

      var card = document.createElement('div');
      card.className = 'kc-wishlist-card';
      card.dataset.variantId = item.variantId;

      card.innerHTML =
        '<div class="kc-wishlist-card__media">' +
          '<a href="' + item.url + '" class="kc-wishlist-card__image-link">' +
            '<img src="' + item.image + '" alt="' + item.title + '" class="kc-wishlist-card__image" loading="lazy" width="400" height="400"/>' +
          '</a>' +
          '<button class="kc-wishlist-card__remove-btn" data-variant-id="' + item.variantId + '" aria-label="' + t('remove') + '">' +
            '<svg xmlns="http://www.w3.org/2000/svg" width="12" height="12" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2.5" stroke-linecap="round" stroke-linejoin="round"><line x1="18" y1="6" x2="6" y2="18"/><line x1="6" y1="6" x2="18" y2="18"/></svg>' +
          '</button>' +
        '</div>' +
        '<div class="kc-wishlist-card__info">' +
          '<a href="' + item.url + '" class="kc-wishlist-card__title-link">' +
            (vendor ? '<span class="kc-wishlist-card__vendor">' + vendor + '</span>' : '') +
            '<span class="kc-wishlist-card__title">' + displayTitle + '</span>' +
          '</a>' +
          '<p class="kc-wishlist-card__price" data-price-id="' + item.variantId + '">–</p>' +
          '<button class="kc-wishlist-card__add-btn button" data-variant-id="' + item.variantId + '">' + t('add_to_cart') + '</button>' +
        '</div>';

      card.querySelector('.kc-wishlist-card__add-btn').addEventListener('click', function () { addToCart(item.variantId, this); });
      card.querySelector('.kc-wishlist-card__remove-btn').addEventListener('click', function () {
        removeFromWishlist(item.variantId);
        card.remove();
        if (grid.children.length === 0) container.innerHTML = '<p class="kc-wishlist-empty">' + t('empty') + '</p>';
        updateAddAllBtn(container);
      });

      grid.appendChild(card);
      return { card: card, item: item };
    });

    container.innerHTML = '';
    container.appendChild(grid);
    updateAddAllBtn(container);

    await Promise.all(cards.map(async function (entry) {
      try {
        var res = await fetch('/variants/' + entry.item.variantId + '.js');
        if (!res.ok) return;
        var data = await res.json();
        var priceEl = container.querySelector('[data-price-id="' + entry.item.variantId + '"]');
        if (priceEl) {
          if (data.price_html) { priceEl.innerHTML = data.price_html; }
          else if (data.price) {
            var currency = (window.Shopify && window.Shopify.currency && window.Shopify.currency.active) || 'SEK';
            priceEl.textContent = (data.price / 100).toFixed(0) + ' ' + currency;
          }
        }
      } catch (e) {}
    }));
  }

  function updateAddAllBtn(container) {
    var existing = container.querySelector('.kc-wishlist-add-all');
    if (existing) existing.remove();
    if (getWishlist().length >= 2) {
      var wrap = document.createElement('div');
      wrap.className = 'kc-wishlist-add-all';
      var btn = document.createElement('button');
      btn.className = 'kc-wishlist-add-all__btn button';
      btn.textContent = t('add_all');
      btn.addEventListener('click', function () { addAllToCart(this); });
      wrap.appendChild(btn);
      container.appendChild(wrap);
    }
  }

  document.addEventListener('click', function (e) {
    var btn = e.target.closest('[data-kc-wishlist-variant]');
    if (btn) handleToggle(btn);
  });

  window.addEventListener('storage', function (e) { if (e.key === STORAGE_KEY) syncAllButtons(); });
  window.addEventListener('kc:wishlist:updated', syncAllButtons);

  // Also re-sync our own wishlist bubble whenever Horizon's own cart updates
  // fire (e.g. quantity changed in drawer, item removed), since those also
  // trigger header-region morphs that could otherwise wipe the bubble.
  document.addEventListener('cart:update', function (e) {
    if (e.detail && e.detail.sourceId === 'kc-wishlist') return; // avoid loop, already handled above
    updateHeaderBubble();
    requestAnimationFrame(updateHeaderBubble);
    setTimeout(updateHeaderBubble, 150);
  });

  function init() {
    syncAllButtons();
    var pageContainer = document.getElementById('kc-wishlist-page');
    if (pageContainer) renderWishlistPage(pageContainer);
    window.addEventListener('kc:wishlist:updated', function () {
      var c = document.getElementById('kc-wishlist-page');
      if (c) renderWishlistPage(c);
    });
  }

  if (document.readyState === 'loading') { document.addEventListener('DOMContentLoaded', init); } else { init(); }

  window.KCWishlist = { getWishlist: getWishlist, addToWishlist: addToWishlist, removeFromWishlist: removeFromWishlist, isInWishlist: isInWishlist, t: t };
})();
